module.exports = require("handlebars");


//////////////////
// WEBPACK FOOTER
// external "handlebars"
// module id = 5
// module chunks = 0


// WEBPACK FOOTER //
// webpack:/external "handlebars"